import request from '@/utils/httpClient'

import { TicketTitleModel } from '@/model/Index'

export const defaultTicketTitleModel: TicketTitleModel = {
  id: 0,
  name: '',
  taxId: '',
  taxRate: '',
  sealImg: '',
  registeredAddress: '',
  officeAddress: '',
  bank: '',
  account: '',
  phone: '',
  bankCode: ''
}
// 批量删除
export function deleteTicketTitleById(id: number) {
  return request({
    url: `ticketTitle/${id}`,
    method: 'delete'
  })
}

// 获取详情
export function getTicketTitleDetailById(id: number | string) {
  return request({
    url: `ticketTitle/${id}`,
    method: 'get'
  })
}

// 获取列表
export function getTicketTitleList(params?: object) {
  return request({
    url: 'ticketTitle/page',
    method: 'get',
    params
  })
}

// 获取下拉数据
export function getTicketTitleDropdown(params?: object) {
  return request({
    url: 'ticketTitle/dropdown',
    method: 'get',
    params
  })
}
